import { Listings } from 'containers/AppContainer/typings';
import React, { useState, useMemo, useRef, useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { cloneDeep, get, isEmpty, isNil, uniqueId } from 'lodash';
import ImportImagineDocumentButton from 'containers/CourtManagerLegalProceedings/ImagineDocuments/ImportButton';
import { Container } from 'containers/LawyerLegalProceedingsPage/judgementAdd/styled-components';
import {
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import ProcedureInformationRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/ProcedureInformationRecap';
import { translate } from 'containers/services/translate';
import judgementAddPronouncingMessages from 'containers/LawyerLegalProceedingsPage/AppealAdd/messages';
import JudgementAddPronouncingRecapAccordion from 'containers/LawyerLegalProceedingsPage/AppealAdd/Recap/index';
import * as featureService from 'features/fflip-helpers';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { FEATURES } from 'features/features';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import messages from 'containers/common/LegalProceedings/AppealAdd/messages';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import {
  EMPTY_ADD,
  EMPTY_INVOICE_INFO,
  PROCEDURE_STATUSES,
  PROCEDURE_STEPS,
} from 'containers/data-structure';
import {
  CorporealDocument,
  JudgementADDDocumentType,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import DecisionDropDownSupportDocument from 'containers/common/LegalProceedings/DecisionDropDownSupportDocument';

import { isAllValuesIsNil, resolveSagisClaim } from 'helpers/utils';
import AppealAddForm from 'containers/LawyerLegalProceedingsPage/AppealAdd/AppealAddPronouncing/AppealAddForm';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { toast } from 'react-toastify';
import { Forms } from 'containers/common/LegalProceedings/AppealAdd/styled-component';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import JudgementValidationButtons from 'containers/common/LegalProceedings/JudgementValidationButtons';
import SuccessDialog from 'components/SuccessDialog';
import {
  activateMultipleJudgementAdd,
  getValueByCode,
  isDuplicateJudgementsAdd,
} from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import { DOCUMENT_TYPES } from 'constants/global';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { SUPPORT_DOC_JUDGEMENT_ADD_ID } from 'containers/LawyerRecapPage/constants';
import { getLimitInvoiceManager, handleOpenDocument } from 'services/utils';
import Document from 'components/Document';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
  isUserActive,
  showValidator,
} from 'containers/common/LegalProceedings/utils';
import { extractIntervenant } from 'containers/RecapPage/utils';
import ValidatorRecap from 'containers/common/LegalProceedings/ValidatorRecap';
import { useSelector } from 'react-redux';
import { isMonitoringCourtManager } from 'helpers/utils';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import FirmReferenceForm from 'components/FirmReferenceForm';
import { Grid, Typography } from '@material-ui/core';
import JudgementAddDecisionRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/JudgementAddDecisionRecap';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { formatInvoiceFeeNoteInfos } from 'containers/LawyerLegalProceedingsPage/utils';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import UpdateStepRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/UpdateStepRecap';
import { DIALOGS } from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import { BUTTON_COLORS } from 'constants/design';
import { formatIntervenants } from 'containers/RecapPage/utils';
import InvoiceFeeNoteDialog from 'components/InvoiceFeeNoteDialog';
import InvoiceInfoDialog from 'components/InvoiceFeeNoteDialog/InvoiceInfoDialog';
import { FeeNoteType } from 'typings/globalTypes';
import { getLimitInvoiceIntervenant } from 'services/utils';
import DynamiqDialog from 'components/InvoiceFeeNoteDialog/DynamiqDialog';
import InvoiceFeeNotesManagerDialog from 'components/InvoiceFeeNoteDialog/InvoiceFeeNotesManagerDialog';
import moment from 'moment-timezone';
import { hasIncomeCertificate } from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/utils';
import IncomeCertificatesRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/IncomeCertificatesRecap/index';
import IncomeCertificate from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate';
import {
  getPendingFeeNotesByStep,
  getVictims,
  getVictimsIncome,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { STATUS_PENDING } from 'containers/LawyerFeeNote/constants';
import { isBlockStatusClaim } from 'containers/CourtManagerLegalProceedings/utils';
import { VictimType } from 'typings/globalTypes';
import { makeSelectFeeNotes } from 'containers/LawyerFeeNote/selectors';
export interface RecapADDProps {
  intl: IntlShape;
  listings: Listings;
  judgementAdd: IJudgementAdd | {};
  readOnly?: boolean;
  //using any temporarly until we implement hooks to pass props between components and drawers
  handleOnEditCivilPartyClick?: any;
  handleOnEditJudgementAddClick?: any;
  handleOnEditProcedureInfoClick?: any;
  stakeholders?: any;
  assignedLawyer?: any;
  victims: VictimType[];
  vehicules: Vehicule[];
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestCreateMultipleJudgementAdd?: Function;
  claimNumber: string;
  judiciaryProcessId: number;
  isManager: boolean;
  documentAdd?: CorporealDocument;
  setDocumentAdd?: Function;
  setDocumentId: Function;
  documentId: string;
  manager?: boolean;
  requestMakeJudgementAddDocumentDecision?: Function;
  setJudgementAdd?: Function;
  judgementAddStore?: IJudgementAdd;
  requestUpdateJudgementAddDocument?: Function;
  currentJudiciaryProcess?: any;
  isCivilProceeding: boolean;
  isAssignedLawyer?: boolean;
  setDialogOpenFirmReference?: Function;
  isCreator?: boolean;
  requestGetJudgementAdd?: Function;
  expertReport?: ExpertReportType;
  judgementOnMerits?: JudgementOnMeritsType;
  handleIsDialogOpen?: Function;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  setIsButtonRedirect?: Function;
  feeNotes: any;
  setOpenFeeNoteDialog: Function;
  isConsultation: boolean;
  requestCreateIncomeCertificate: Function;
  requestUpdateIncomeCertificate: Function;
  requestMakeDecisionIncomeCertificate: Function;
  requestMakeDecisionSupportDocument?: Function;
  riskKey: string;
  imagineDocuments: any;
  policyInfo: any;
  dahirAmount: [];
  civilDocumentsVictims?: [];
  requestGetDocByDocumentumId: Function;
}

export const RecapADD: React.FC<RecapADDProps> = (props): JSX.Element => {
  const {
    judgementAdd,
    judgementAddDocuments,
    supportDocuments = [],
  } = props.judgementAdd as IJudgementAdd;
  const [
    judgemenAddDocumentToUpdate,
    setJudgemenAddDocumentToUpdate,
  ] = useState({});
  const judgementAddSupportDocuments = supportDocuments.filter(
    (el: any) => el.type === DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ADD,
  );
  const claimAssignment = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'assignment'], []),
  );
  const claimRecap = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap']),
  );
  const claim = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap'], []),
  );
  const claimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'id'], []),
  );
  const feeNotesStore = useSelector(makeSelectFeeNotes());
  const [
    openInvoiceFeeNoteUpdateInfoDialog,
    setOpenInvoiceFeeNoteUpdateInfoDialog,
  ] = useState<boolean>(false);
  const [
    decisionGenerationFeeNote,
    setDecisionGenerationFeeNote,
  ] = React.useState(null);
  const currentFeeNoteIndexRef = useRef<number>(0);
  const [currentFeeNoteIndex, setCurrentFeeNoteIndex] = useState<number | null>(
    null,
  );
  const [invoiceDocumentUpdate, setInvoiceDocumentUpdate] = useState({});
  const [invoiceNumberUpdate, setInvoiceNumberUpdate] = useState(null);
  const [invoiceDateUpdate, setInvoiceDateUpdate] = useState(null);
  const [invoiceFeeNotes, setInvoiceFeeNotes] = useState([]);

  const feeNotes = useMemo(
    () =>
      getPendingFeeNotesByStep(
        feeNotesStore,
        PROCEDURE_STEPS.ARRET_ADD,
        null as any,
        !isEmpty(judgemenAddDocumentToUpdate)
          ? [get(judgemenAddDocumentToUpdate, 'id')]
          : [],
        currentIntervenantStorage?.get()?.sagis_code,
      ),
    [],
  );

  const [
    openInvoiceFeeNoteInfoDialog,
    setOpenInvoiceFeeNoteInfoDialog,
  ] = React.useState(false);
  const [lawyerFirmRef, setLawyerFirmRef] = React.useState(null);
  const [invoiceDocument, setInvoiceDocument] = React.useState({});
  const [invoiceNumber, setInvoiceNumber] = React.useState(null);
  const [invoiceDate, setInvoiceDate] = React.useState(null);
  const [generateFeeNoteLawyer, setGenerateFeeNoteLawyer] = React.useState<
    boolean
  >(false);
  const [openInvoiceInfoLawyers, setOpenInvoiceInfoLawyers] = React.useState<
    boolean
  >(false);
  const [invoiceFeeNoteInfos, setInvoiceFeeNoteInfo] = React.useState<any>([]);

  const lawyerAssignment = claimAssignment.find(
    (el: any) =>
      el.assignedLawyer === currentIntervenantStorage.get()?.sagis_code &&
      el.judiciaryProcessId === props.judiciaryProcessId &&
      el.isDeleted === false,
  );
  const assignedLawyersByJudiciaryProcess = claimAssignment.filter(
    (el: any) =>
      el.judiciaryProcessId === props.judiciaryProcessId &&
      el.isDeleted === false,
  );
  const lawyerFirmReference = get(lawyerAssignment, 'firmReference', null);
  const [appealAddPronouncings, setAppealAddPronouncings] = useState<any>({
    [uniqueId()]: cloneDeep(EMPTY_ADD),
  });
  const [isSuccessPopinOpen, setIsSuccessPopinOpen] = React.useState<boolean>(
    false,
  );
  const [newAppealADDDocuments, setNewAppealADDDocuments] = useState<
    JudgementADDDocumentType[]
  >([]);
  const [isActive, setisActive] = useState(false);
  const handleValidate = (
    judgemenAddDocumentToUpdateObject: any,
    updatedInvoiceFeeNotes?: any,
  ) => {
    props.requestUpdateJudgementAddDocument &&
      props.requestUpdateJudgementAddDocument(
        {
          judgementAddDocument: {
            ...judgemenAddDocumentToUpdateObject,
            rejectionReason: null,
            status: PROCEDURE_STATUSES.PENDING,
            validator: null,
          },
          claimId: get(props.judgementAdd, 'claimId'),
          procedureType: get(props.judgementAdd, 'procedureType'),
          judiciaryProcessId: get(props.judgementAdd, 'judiciaryProcessId'),
          claimNumber: props.claimNumber,
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
          invoiceFeeNotes: updatedInvoiceFeeNotes,
          isLawyer: currentIntervenantStorage?.get() ? true : false,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
        },
        handleSuccessCallback,
      );
  };
  useEffect(() => {
    if (currentFeeNoteIndex !== null) {
      currentFeeNoteIndexRef.current = currentFeeNoteIndex;
    }
  }, [currentFeeNoteIndex]);
  const handleCloseInvoiceFeeNoteUpdate = () => {
    setOpenInvoiceFeeNoteUpdateInfoDialog(false);
  };
  const handleSuccessCallback = () => {
    toast.success(translate(messages.validationMessage, props));
    pushTo(PAGES.LAWYER_ASSIGNMENTS)();
  };
  const handleValidateInvoiceUpdate = () => {
    const currentItem = feeNotes[currentFeeNoteIndexRef.current];
    const invoiceFeeNoteId = get(currentItem, 'invoiceFeeNote.id');
    const updatedInvoiceFeeNotes = [
      ...invoiceFeeNotes,
      {
        id: invoiceFeeNoteId,
        invoiceNumber: invoiceNumberUpdate,
        invoiceDate: invoiceDateUpdate,
        receptionDate: moment().format('YYYY-MM-DD'),
        ...invoiceDocumentUpdate,
      },
    ];
    setInvoiceFeeNotes(updatedInvoiceFeeNotes as any);

    setInvoiceNumberUpdate(null);
    setInvoiceDocumentUpdate({});
    setInvoiceDateUpdate(null);
    setOpenInvoiceFeeNoteUpdateInfoDialog(false);
    if (
      updatedInvoiceFeeNotes.length ===
      feeNotes.map((el: any) => el.invoiceFeeNote).length
    ) {
      setCurrentFeeNoteIndex(null);
      handleValidate(judgemenAddDocumentToUpdate, updatedInvoiceFeeNotes);
    } else {
      currentFeeNoteIndexRef.current = currentFeeNoteIndexRef.current + 1;
      setCurrentFeeNoteIndex(currentFeeNoteIndexRef.current);
      setOpenInvoiceFeeNoteUpdateInfoDialog(true);
    }
  };
  const addNewAppealAddDocument = () => {
    setisActive(true);
    const judgement = {
      ...appealAddPronouncings,
      [uniqueId()]: cloneDeep(EMPTY_ADD),
    };

    isActive && setAppealAddPronouncings(judgement);
  };
  const handleChangeAppealAddProunoucing = (index: number) => (
    judgement: JudgementADDDocumentType,
  ) => {
    const appealADD = { ...appealAddPronouncings };
    if (!isEmpty(judgement)) {
      appealADD[index] = judgement;
    } else {
      //handling the case when emptying state
      delete appealADD[index];
    }

    setAppealAddPronouncings(appealADD);
  };
  const [showDuplicateWarning, setShowDuplicateWarning] = useState<boolean>(
    false,
  );
  const cancelJudgement = (index: number) => () => {
    let judgement = { ...appealAddPronouncings };
    delete judgement[index];
    setAppealAddPronouncings(judgement);
  };
  const saveForm = (judgement: any) => {
    if (isDuplicateJudgementsAdd(judgement, judgementAddDocuments)) {
      return setShowDuplicateWarning(true);
    }
    const JAD = [...newAppealADDDocuments];
    JAD.push({
      ...judgement,
      byManager: props.isManager,
    });
    setNewAppealADDDocuments(JAD);
    setShowDuplicateWarning(false);
  };

  const createMultipleAppealAdd = (withFeeNote: boolean) => {
    props.isManager &&
      props.setIsButtonRedirect &&
      props.setIsButtonRedirect(true);
    props.requestCreateMultipleJudgementAdd &&
      props.requestCreateMultipleJudgementAdd(
        {
          id: get(judgementAdd, 'id', ''),
          isLawyer: !props.isManager,
          lawyerCode: !props.isManager
            ? currentIntervenantStorage.get() &&
              currentIntervenantStorage.get().sagis_code
            : undefined,
          claimId: get(props.judgementAdd, 'claimId', ''),
          claimNumber: props.claimNumber,
          procedureType: PROCEDURE_TYPES.APPEAL,
          judiciaryProcessId: props.judiciaryProcessId,
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
          isCompanyIntervenants: formatIntervenants(
            assignedLawyersByJudiciaryProcess,
          ),
          decisionGenerationFeeNote: decisionGenerationFeeNote,
          invoiceFeeNoteInfos:
            !isEmpty(invoiceFeeNoteInfos) &&
            props.isManager &&
            featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE)
              ? formatInvoiceFeeNoteInfos(invoiceFeeNoteInfos)
              : [],
          lawyerFirmReference: lawyerFirmRef,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          assignementId: get(lawyerAssignment, 'id'),
          feeNote: withFeeNote
            ? {
                step: PROCEDURE_STEPS.ARRET_ADD,
                codeIntervenant:
                  currentIntervenantStorage.get() &&
                  currentIntervenantStorage.get().sagis_code,
                status: STATUS_PENDING,
                judgementDate: get(
                  newAppealADDDocuments,
                  '[0].judgementDate',
                  '',
                ),
                firmReference: isNil(lawyerFirmReference)
                  ? lawyerFirmRef
                  : lawyerFirmReference,
                invoiceFeeNote:
                  featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
                  !props.isManager &&
                  !isAllValuesIsNil({
                    invoiceNumber: invoiceNumber,
                    invoiceDate: invoiceDate,
                    ...invoiceDocument,
                  })
                    ? {
                        codeIntervenant:
                          currentIntervenantStorage.get() &&
                          currentIntervenantStorage.get().sagis_code,
                        createdBy:
                          currentIntervenantStorage?.get() &&
                          currentIntervenantStorage?.get()?.preferred_username,
                        invoiceNumber: invoiceNumber,
                        invoiceDate:
                          invoiceDate === 'Invalid date' ? null : invoiceDate,
                        receptionDate: moment().format('YYYY-MM-DD'),
                        ...invoiceDocument,
                        isIndexed: false,
                      }
                    : undefined,
              }
            : undefined,
          judgementAddDocuments: newAppealADDDocuments,
          isLawyerInboxesActive: featureService.hasFeature(
            FEATURES.LAWYER_INBOXES,
          ),
        },
        successCallBack(withFeeNote),
      );
  };

  const successCallBack = (withFeeNote: boolean) => () => {
    setNewAppealADDDocuments([]);
    toast.success(translate(messages.successToastTitle, props));

    withFeeNote && !props.isManager
      ? pushTo(PAGES.FEE_NOTE)()
      : !withFeeNote && !props.isManager && pushTo(PAGES.LAWYER_ASSIGNMENTS)();
  };
  React.useEffect(() => {
    if (props.isManager && !isEmpty(assignedLawyersByJudiciaryProcess)) {
      if (
        !isEmpty(
          extractIntervenant(
            get(props.listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ),
        )
      ) {
        setInvoiceFeeNoteInfo(
          extractIntervenant(
            get(props.listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ).map((item: any, index: any) => ({
            codeIntervenant: item.ItemKey,
            createdBy:
              currentUserStorage?.get() && currentUserStorage?.get().username,
            ...EMPTY_INVOICE_INFO,
          })),
        );
      }
    }
  }, [
    props.judiciaryProcessId,
    props.riskKey,
    props.currentJudiciaryProcess,
    !claimAssignment,
  ]);
  const onValidate = () => {
    props.isManager
      ? !isEmpty(
          extractIntervenant(
            get(props.listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ),
        )
        ? setGenerateFeeNoteLawyer(true)
        : createMultipleAppealAdd(true)
      : setIsSuccessPopinOpen(true);
  };

  const handleClick = () => {
    createMultipleAppealAdd(true);
  };

  const doNotGenerateFeeNote = () => {
    createMultipleAppealAdd(false);
  };
  const hasValidator = showValidator(
    get(props, 'judgementAdd.validator', ''),
    props.isManager,
  );

  const handleOpenInvoicesInfoDialog = () => {
    setIsSuccessPopinOpen(false);
    setOpenInvoiceFeeNoteInfoDialog(true);
  };

  const handleCloseSuccessDialog = () => {
    setIsSuccessPopinOpen(false);
    doNotGenerateFeeNote();
  };

  const handleValidateInvoice = () => {
    handleClick();
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleCloseInvoiceFeeNote = () => {
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleOpenInvoicesInfoLawyersDialog = () => {
    setGenerateFeeNoteLawyer(false);
    setOpenInvoiceInfoLawyers(true);
  };

  const currentlawyerAssignment =
    claimAssignment.find(
      (el: any) =>
        el.judiciaryProcessId === props.judiciaryProcessId &&
        el.isDeleted === false,
    ) || {};
  return (
    <Container>
      {props.isManager && (
        <div style={{ fontWeight: 'bold', fontSize: '18px', color: 'red' }}>
          {!isUserActive(
            props.listings,
            get(currentlawyerAssignment, 'assignedLawyer'),
          ) &&
          !isEmpty(currentlawyerAssignment) &&
          !isEmpty(props.listings)
            ? translate(messages.userNotValidWarning, props, {
                lawyerName: getValueByCode(
                  get(currentlawyerAssignment, 'assignedLawyer', ''),
                  get(props.listings, 'inactiveIntervenants', []),
                ),
              })
            : ''}
        </div>
      )}
      {props.isManager && (
        <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
          {get(props, 'judgementAdd.creator', '')
            ? translate(messages.creatorTitle, props, {
                lawyer: get(props, 'judgementAdd.creator', ''),
              })
            : ''}
        </span>
      )}
      {!props.isManager &&
        !isBlockStatusClaim(props.policyInfo) &&
        lawyerAssignment && (
          <FirmReferenceForm
            firmReference={lawyerFirmReference}
            message={
              lawyerFirmReference === null
                ? translate(messages.lawyerFirmReferenceUpdateMessage, props)
                : translate(messages.lawyerFirmReferenceEditMessage, props)
            }
            formInputLabel={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            formInputName={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            validationButtonTitle={
              lawyerFirmReference === null
                ? translate(messages.saveButton, props)
                : translate(messages.editButton, props)
            }
            setIsDialogOpenFirmReference={props.setDialogOpenFirmReference}
            title={
              get(props, 'judgementAdd.creator', '')
                ? translate(messages.creatorTitle, props, {
                    lawyer: get(props, 'judgementAdd.creator', ''),
                  })
                : ''
            }
            isFeeNoteGenerated={false}
            judiciaryProcessId={props.judiciaryProcessId}
            lawyerFirmReference={lawyerFirmReference}
            assignment={lawyerAssignment}
            isForm
          />
        )}

      {(hasValidator ||
        userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER)) &&
        get(props, 'judgementAdd.status', '') !==
          PROCEDURE_STATUSES.PENDING && (
          <Grid container direction="column">
            <Grid xs={3}>
              <ValidatorRecap
                validator={get(props, 'judgementAdd.validator', '')}
              />
            </Grid>
            <Grid xs={6}>
              <JudgementAddDecisionRecap
                judgementAdd={props.judgementAdd}
                judgementAddDocument={judgementAddDocuments as any}
              />
            </Grid>
          </Grid>
        )}
      <UpdateStepRecap updatedBy={get(props, 'judgementAdd.updatedBy', '')} />
      <section className="add-recap-bloc">
        {judgementAdd && (
          <ProcedureInformationRecap
            listings={props.listings}
            details={judgementAdd}
            readOnly={props.readOnly || !props.isCreator}
            handleOnEditClick={
              props.handleOnEditProcedureInfoClick &&
              props.handleOnEditProcedureInfoClick()
            }
            stakeholders={props.stakeholders}
            assignedLawyer={props.assignedLawyer}
            sagisOpposingParties={props.sagisOpposingParties}
          />
        )}
        <div className="update-button">
          {props.isManager &&
            featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
            get(props, 'judgementAdd.status', '') !==
              PROCEDURE_STATUSES.PENDING && (
              <PrimaryButton
                title={translate(messages.courtManagerJudgementUpdate, props)}
                onClick={
                  props.handleIsDialogOpen &&
                  props.handleIsDialogOpen(DIALOGS.VALIDATION, true, true, true)
                }
                background={BUTTON_COLORS.PRIMARY_BLUE}
                border={BUTTON_COLORS.PRIMARY_BLUE}
                titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                className="button"
              />
            )}
        </div>
      </section>
      <Forms>
        {!userPrivileges.userHasPrivilege(
          PRIVILEGES.ISCOURTMONITORINGMANAGER,
        ) &&
          activateMultipleJudgementAdd(props.judgementAdd, props.isManager) &&
          props.isAssignedLawyer && (
            <div className="add-document">
              <PrimaryButton
                title={translate(messages.addNewAddDocumentAppeal, props)}
                lefticon={<AddCircleOutlineIcon className="icon" />}
                onClick={addNewAppealAddDocument}
                className="add-judgement-add-pronoucing-style"
              />
            </div>
          )}
        {judgementAdd && !isEmpty(judgementAddDocuments) && (
          <div className="add-recap-bloc-title">
            {translate(
              judgementAddPronouncingMessages.appealAddPronouncingTitle,
              props,
            )}
          </div>
        )}
        {
          <div
            style={{
              margin: '5px',
              fontWeight: 'bold',
              fontSize: '18px',
              color: 'red',
            }}
          >
            {showDuplicateWarning
              ? translate(messages.duplicateJaddWarning, props)
              : ''}
          </div>
        }
        {!isEmpty(judgementAddDocuments) &&
          judgementAddDocuments.map((judgemenAddDocument, index: number) => (
            <JudgementAddPronouncingRecapAccordion
              key={uniqueId('recap-judgementAdd-')}
              index={index}
              listings={props.listings}
              judgementAddDocument={judgemenAddDocument}
              judgementAdd={props.judgementAdd}
              claimNumber={props.claimNumber}
              readOnly={
                props.readOnly ||
                (props.isManager
                  ? false
                  : (get(judgemenAddDocument, 'lawyerCode')
                      ? get(judgemenAddDocument, 'lawyerCode')
                      : get(props.judgementAdd, 'lawyerCode')) !=
                    currentIntervenantStorage.get()?.sagis_code)
              }
              editJudgementAdd={
                !isMonitoringCourtManager()
                  ? props.handleOnEditJudgementAddClick &&
                    props.handleOnEditJudgementAddClick(index)
                  : undefined
              }
              isManager={props.isManager && !props.isConsultation}
              isConsultation={props.isConsultation}
              requestMakeJudgementAddDocumentDecision={
                props.requestMakeJudgementAddDocumentDecision
              }
              setJudgementAdd={props.setJudgementAdd}
              requestUpdateJudgementAddDocument={
                props.requestUpdateJudgementAddDocument
              }
              isSaved
              judiciaryProcessId={props.judiciaryProcessId}
              setDialogOpenFirmReference={props.setDialogOpenFirmReference}
              isAssignedLawyer={props.isAssignedLawyer}
              requestGetJudgementAdd={props.requestGetJudgementAdd}
              judgementAddDocumentIds={get(
                props.judgementAdd,
                'judgementAddDocuments',
                [],
              ).map((item: any) => get(item, 'id', ''))}
              expertReport={props.expertReport}
              judgementOnMerits={props.judgementOnMerits}
              handleIsDialogOpen={props.handleIsDialogOpen}
              sagisVictimInfo={props.sagisVictimInfo}
              sagisOpposingParties={props.sagisOpposingParties}
              claimAssignment={claimAssignment}
              feeNotes={props.feeNotes}
              setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
              policyInfo={props.policyInfo}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              resetUploadedDocument={props.resetUploadedDocument}
              setDocumentId={props.setDocumentId}
              setOpenInvoiceFeeNoteUpdateInfoDialog={
                setOpenInvoiceFeeNoteUpdateInfoDialog
              }
              openInvoiceFeeNoteUpdateInfoDialog={
                openInvoiceFeeNoteUpdateInfoDialog
              }
              handleValidateUpdateJudgementAddDocument={handleValidate}
              setJudgemenAddDocumentToUpdate={setJudgemenAddDocumentToUpdate}
            />
          ))}
        {!isEmpty(newAppealADDDocuments) &&
          newAppealADDDocuments.map((appealAddDocument, index: number) => (
            <JudgementAddPronouncingRecapAccordion
              key={uniqueId('recap-judgementAdd-')}
              index={index}
              listings={props.listings}
              judgementAddDocument={appealAddDocument}
              readOnly={
                props.readOnly ||
                (props.isManager
                  ? true
                  : get(appealAddDocument, 'lawyerCode') !=
                    currentIntervenantStorage.get()?.sagis_code)
              }
              editJudgementAdd={
                !isMonitoringCourtManager()
                  ? props.handleOnEditJudgementAddClick &&
                    props.handleOnEditJudgementAddClick(index)
                  : undefined
              }
              judgementAdd={props.judgementAdd}
              isManager={props.isManager}
              isConsultation={props.isConsultation}
              claimNumber={props.claimNumber}
              requestMakeJudgementAddDocumentDecision={
                props.requestMakeJudgementAddDocumentDecision
              }
              setJudgementAdd={props.setJudgementAdd}
              requestUpdateJudgementAddDocument={
                props.requestUpdateJudgementAddDocument
              }
              isAssignedLawyer={props.isAssignedLawyer}
              requestGetJudgementAdd={props.requestGetJudgementAdd}
              expertReport={props.expertReport}
              judgementOnMerits={props.judgementOnMerits}
              handleIsDialogOpen={props.handleIsDialogOpen}
              sagisVictimInfo={props.sagisVictimInfo}
              sagisOpposingParties={props.sagisOpposingParties}
              feeNotes={props.feeNotes}
              claimAssignment={claimAssignment}
              setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
              policyInfo={props.policyInfo}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              resetUploadedDocument={props.resetUploadedDocument}
              setDocumentId={props.setDocumentId}
              setOpenInvoiceFeeNoteUpdateInfoDialog={
                setOpenInvoiceFeeNoteUpdateInfoDialog
              }
              openInvoiceFeeNoteUpdateInfoDialog={
                openInvoiceFeeNoteUpdateInfoDialog
              }
              handleValidateUpdateJudgementAddDocument={handleValidate}
              setJudgemenAddDocumentToUpdate={setJudgemenAddDocumentToUpdate}
            />
          ))}
        {featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) &&
          !isEmpty(feeNotes) &&
          feeNotes.map((item: FeeNoteType) => (
            <InvoiceInfoDialog
              open={openInvoiceFeeNoteUpdateInfoDialog}
              onClose={handleCloseInvoiceFeeNoteUpdate}
              handleValidate={handleValidateInvoiceUpdate}
              invoiceNumber={invoiceNumberUpdate}
              invoiceDate={invoiceDateUpdate}
              setInvoiceNumber={setInvoiceNumberUpdate}
              setInvoiceDate={setInvoiceDateUpdate}
              resetUploadedDocument={props.resetUploadedDocument}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              invoiceDocument={invoiceDocumentUpdate}
              setInvoiceDocument={setInvoiceDocumentUpdate}
              setDocumentId={props.setDocumentId}
              displayUpdateTitle={true}
              docId={'UPDATE_FACTURE'}
              isManager={false}
              limitInvoiceDate={getLimitInvoiceIntervenant(
                get(props.listings, 'appConfig', []),
              )}
            />
          ))}

        {isActive &&
          !isEmpty(appealAddPronouncings) &&
          Object.entries(appealAddPronouncings).map(
            ([key, judgement]: any, index: number) => {
              return (
                <AppealAddForm
                  key={key}
                  listings={props.listings}
                  victims={getVictims(
                    props.isCivilProceeding,
                    props.currentJudiciaryProcess,
                    props.civilDocumentsVictims
                      ? props.civilDocumentsVictims
                      : (props.judgementAdd as any),
                    props.victims,
                    claimRecap,
                  )}
                  judgementAddPronouncing={judgement}
                  vehicules={props.vehicules}
                  uploadDocument={props.uploadDocument}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadedDocument={props.resetUploadedDocument}
                  handleSetJudgementAddPronouncing={handleChangeAppealAddProunoucing(
                    key,
                  )}
                  index={key}
                  details={get(props.judgementAdd, 'judgementAdd', {})}
                  saveForm={saveForm}
                  cancelJudgement={cancelJudgement(key)}
                  indexMap={index}
                  sagisVictimInfo={props.sagisVictimInfo}
                  sagisOpposingParties={props.sagisOpposingParties}
                  imagineDocuments={props.imagineDocuments}
                  claimId={claimId}
                  isManager={userPrivileges.userHasPrivilege(
                    PRIVILEGES.ISCOURTMANAGER,
                  )}
                  policyInfo={props.policyInfo}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                />
              );
            },
          )}
      </Forms>
      {((featureService.hasFeature(FEATURES.ADD_SUPPORT_DOCUMENTS) &&
        !userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER) &&
        judgementAdd &&
        props.isAssignedLawyer) ||
        (props.isManager &&
          featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER))) && (
        <main>
          {isEmpty(judgementAddSupportDocuments) && (
            <section className="add-recap-bloc">
              {props.documentAdd &&
                props.setDocumentAdd &&
                props.resetUploadedDocument &&
                props.uploadDocument &&
                props.uploadedDocument && (
                  <>
                    <div className="add-recap-bloc-title">
                      {translate(messages.supportDocument, props)}
                    </div>
                    <Grid container direction="row" spacing={2}>
                      <Grid item xs={4}>
                        <UploadDocumentBloc
                          index={1}
                          document={props.documentAdd}
                          setDocument={props.setDocumentAdd}
                          resetUploadedDocument={props.resetUploadedDocument}
                          uploadDocument={props.uploadDocument}
                          uploadedDocument={props.uploadedDocument}
                          docType={DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ADD}
                          setDocumentId={props.setDocumentId}
                          docId={SUPPORT_DOC_JUDGEMENT_ADD_ID}
                        />
                      </Grid>
                      <Grid item xs={3} style={{ marginTop: '20px' }}>
                        {!isEmpty(props.imagineDocuments) &&
                          props.isManager &&
                          featureService.hasFeature(
                            FEATURES.TRAITEMENT_IMAGINE_DOC,
                          ) && (
                            <ImportImagineDocumentButton
                              listings={props.listings}
                              managerNotifcationsInboxes={
                                props.imagineDocuments
                              }
                              claimId={claimId}
                              imagineDocuments={props.imagineDocuments}
                              claimSagisInfo={resolveSagisClaim(
                                props.policyInfo,
                              )}
                              uploadDocument={props.uploadDocument}
                              uploadedDocument={props.uploadedDocument}
                              setUploadedDocs={props.setDocumentAdd}
                              documentName={
                                DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ADD
                              }
                              documentType={
                                DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ADD
                              }
                              requestGetDocByDocumentumId={
                                props.requestGetDocByDocumentumId
                              }
                              documentId={SUPPORT_DOC_JUDGEMENT_ADD_ID}
                              setDocumentId={
                                props.setDocumentId
                                  ? props.setDocumentId
                                  : () => {}
                              }
                            />
                          )}
                      </Grid>
                    </Grid>
                  </>
                )}
            </section>
          )}
        </main>
      )}
      {!isEmpty(judgementAddSupportDocuments) &&
        featureService.hasFeature(FEATURES.ADD_SUPPORT_DOCUMENTS) && (
          <section className="add-recap-bloc">
            <div className="add-recap-bloc-title">
              {translate(messages.supportDocument, props)}
            </div>
            <div className="support-document-info">
              <Document
                name={get(judgementAddSupportDocuments[0], 'name', '')}
                type={get(judgementAddSupportDocuments[0], 'type', '')}
                icon={
                  <VisibilityIcon
                    className="consult"
                    onClick={handleOpenDocument(
                      judgementAddSupportDocuments[0] as any,
                      props.requestGetDocByDocumentumId,
                    )}
                  />
                }
              />
              {props.isManager && !props.isConsultation && (
                <DecisionDropDownSupportDocument
                  claimId={claimId as any}
                  claimNumber={props.claimNumber as any}
                  judiciaryProcessId={props.judiciaryProcessId}
                  supportDocument={judgementAddSupportDocuments[0]}
                  requestMakeDecisionSupportDocument={
                    props.requestMakeDecisionSupportDocument
                  }
                  claim={claim}
                  procedureType={PROCEDURE_TYPES.APPEAL}
                />
              )}
            </div>
          </section>
        )}
      {!isEmpty(newAppealADDDocuments) && (
        <JudgementValidationButtons
          onValidation={onValidate}
          onCancel={() => setNewAppealADDDocuments([])}
          cancelMessage={messages.cancelMessage}
        />
      )}
      {featureService.hasFeature(FEATURES.INCOME_CERTIFICATE) && (
        <React.Fragment>
          {!props.isConsultation &&
          !hasIncomeCertificate(
            getVictimsIncome(
              props.isCivilProceeding,
              props.currentJudiciaryProcess,
              props.civilDocumentsVictims
                ? props.civilDocumentsVictims
                : (props.judgementAdd as any),
              props.victims,
              claimRecap,
            ),
          ) &&
          !userPrivileges.userHasPrivilege(
            PRIVILEGES.ISCOURTMONITORINGMANAGER,
          ) ? (
            <IncomeCertificate
              victims={getVictimsIncome(
                props.isCivilProceeding as any,
                props.currentJudiciaryProcess,
                props.civilDocumentsVictims
                  ? props.civilDocumentsVictims
                  : (props.judgementAdd as any),
                props.victims,
                claimRecap,
              )}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              resetUploadedDocument={props.resetUploadedDocument}
              sagisVictimInfo={props.sagisVictimInfo}
              requestCreateIncomeCertificate={
                props.requestCreateIncomeCertificate
              }
              isManager={userPrivileges.userHasPrivilege(
                PRIVILEGES.ISCOURTMANAGER,
              )}
              setDocumentId={props.setDocumentId}
              documentId={props.documentId}
              claimNumber={props.claimNumber}
              claimId={claimId}
              judiciaryProcessId={props.judiciaryProcessId}
              dahirAmount={props.dahirAmount}
              riskKey={props.riskKey}
              claim={claim}
              listings={props.listings}
            />
          ) : (
            <IncomeCertificatesRecap
              victims={getVictimsIncome(
                props.isCivilProceeding as any,
                props.currentJudiciaryProcess,
                props.civilDocumentsVictims
                  ? props.civilDocumentsVictims
                  : (props.judgementAdd as any),
                props.victims,
                claimRecap,
              )}
              sagisVictimInfo={props.sagisVictimInfo}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              resetUploadedDocument={props.resetUploadedDocument}
              requestCreateIncomeCertificate={
                props.requestCreateIncomeCertificate
              }
              requestUpdateIncomeCertificate={
                props.requestUpdateIncomeCertificate
              }
              isManager={userPrivileges.userHasPrivilege(
                PRIVILEGES.ISCOURTMANAGER,
              )}
              setDocumentId={props.setDocumentId}
              documentId={props.documentId}
              claimNumber={props.claimNumber}
              claimId={claimId}
              judiciaryProcessId={props.judiciaryProcessId}
              readOnly={props.readOnly}
              requestMakeDecisionIncomeCertificate={
                props.requestMakeDecisionIncomeCertificate
              }
              isConsultation={props.isConsultation}
              riskKey={props.riskKey}
              claim={claim}
              judgementAdd={props.judgementAdd}
              dahirAmount={props.dahirAmount}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
              listings={props.listings}
            />
          )}
        </React.Fragment>
      )}
      {!props.isManager &&
      featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) ? (
        <InvoiceFeeNoteDialog
          open={isSuccessPopinOpen}
          onClose={() => setIsSuccessPopinOpen(false)}
          decisionGenerationFeeNote={decisionGenerationFeeNote}
          setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
          handleValidate={
            decisionGenerationFeeNote
              ? handleOpenInvoicesInfoDialog
              : handleCloseSuccessDialog
          }
          shouldDisplayFirmReferenceField={
            isEmpty(lawyerFirmReference) && !props.isManager
          }
          setLawyerFirmRef={setLawyerFirmRef}
          lawyerFirmRef={lawyerFirmRef}
        />
      ) : (
        <SuccessDialog
          title={translate(messages.successDialogTitle, props)}
          secondaryButtonTitle={translate(
            messages.successDialogSecondaryButtonTitle,
            props,
          )}
          primaryButtonTitle={
            featureService.hasFeature(FEATURES.FEE_NOTE)
              ? translate(messages.successAppealAdd, props)
              : translate(messages.successDialogPrimaryButtonTitle, props)
          }
          tertiaryButtonTitle={translate(
            { ...messages.doNotGenerateFeeNote },
            props,
          )}
          onTertiaryClick={doNotGenerateFeeNote}
          open={isSuccessPopinOpen}
          onClose={setIsSuccessPopinOpen}
          homePath={PAGES.LAWYER_HOME}
          onPrimaryClick={handleClick}
          isExpertReport={false}
          isPrimaryButtonDisabled={
            isEmpty(lawyerFirmReference) && !props.isManager
          }
        />
      )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
        <InvoiceInfoDialog
          open={openInvoiceFeeNoteInfoDialog}
          onClose={handleCloseInvoiceFeeNote}
          handleValidate={handleValidateInvoice}
          invoiceNumber={invoiceNumber}
          invoiceDate={invoiceDate}
          setInvoiceNumber={setInvoiceNumber}
          setInvoiceDate={setInvoiceDate}
          resetUploadedDocument={props.resetUploadedDocument}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          invoiceDocument={invoiceDocument}
          setInvoiceDocument={setInvoiceDocument}
          limitInvoiceDate={getLimitInvoiceIntervenant(
            get(props.listings, 'appConfig', []),
          )}
        />
      )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
        props.isManager && (
          <InvoiceFeeNoteDialog
            open={generateFeeNoteLawyer}
            onClose={() => setGenerateFeeNoteLawyer(false)}
            decisionGenerationFeeNote={decisionGenerationFeeNote}
            setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
            handleValidate={
              decisionGenerationFeeNote
                ? handleOpenInvoicesInfoLawyersDialog
                : () => {
                    setInvoiceFeeNoteInfo([]);
                    createMultipleAppealAdd(false);
                    setGenerateFeeNoteLawyer(false);
                  }
            }
            shouldDisplayFirmReferenceField={
              isEmpty(lawyerFirmReference) && !props.isManager
            }
            setLawyerFirmRef={setLawyerFirmRef}
            lawyerFirmRef={lawyerFirmRef}
          />
        )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
        <DynamiqDialog
          open={openInvoiceInfoLawyers}
          onClose={() => setOpenInvoiceInfoLawyers(false)}
          handleValidate={() => {
            createMultipleAppealAdd(true);
            setOpenInvoiceInfoLawyers(false);
          }}
          children={
            <>
              {extractIntervenant(
                get(props.listings, 'intervenants'),
                assignedLawyersByJudiciaryProcess,
              )?.map((item: any, index: any) => (
                <div style={{ marginTop: 10 }}>
                  <Typography style={{ fontWeight: 700 }}>
                    {translate(messages.intervenantName, props, {
                      IntervenantName: get(item, 'ItemDescription', null),
                    })}
                  </Typography>
                  <InvoiceFeeNotesManagerDialog
                    invoiceFeeNoteInfo={invoiceFeeNoteInfos[index]}
                    listings={props.listings}
                    invoiceFeeNoteInfos={invoiceFeeNoteInfos}
                    resetUploadedDocument={props.resetUploadedDocument}
                    uploadedDocument={props.uploadedDocument}
                    uploadDocument={props.uploadDocument}
                    assignedLawyersByJudiciaryProcess={
                      assignedLawyersByJudiciaryProcess
                    }
                    setDocumentId={
                      props.setDocumentId ? props.setDocumentId : () => {}
                    }
                    documentId={props.documentId}
                    setInvoiceFeeNoteInfo={setInvoiceFeeNoteInfo}
                    index={index}
                    displayFirmReferenceInput={
                      isNil(get(item, 'firmReference', null)) &&
                      featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE)
                    }
                    limitInvoiceDate={getLimitInvoiceManager(
                      get(props.listings, 'appConfig', []),
                    )}
                  />
                </div>
              ))}
            </>
          }
        />
      )}
    </Container>
  );
};

export default injectIntl(RecapADD);
